module.exports = __webpack_public_path__ + "img/loginc.c2746dd7.png";